// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import './components'
import './permission'
import md5 from 'js-md5'
import './icons' // icon
import { parseTime } from '@/utils'
import 'element-ui/lib/theme-chalk/index.css';

import { selectDictLabel } from "@/utils/index";
Vue.prototype.selectDictLabel = selectDictLabel

Vue.config.productionTip = false
Vue.prototype.$md5 = md5
Vue.prototype.Agent = '/agent'
Vue.prototype.Merchant = '/merchant'
Vue.prototype.Manage = '/admin'
Vue.prototype.AgentHost = ['agent.dhhpay.com']//代理
Vue.prototype.MerchantHost = ['merch.dhhpay.com']//商户
Vue.prototype.ManageHost = ['admin.dhhpay.com']//总控
// Vue.prototype.ManageHost = ['192.168.1.49']//gogo
// Vue.prototype.ManageHost = ['192.168.1.5']//poppy
Vue.prototype.ManageHostAndMerchantHost = [...Vue.prototype.MerchantHost, ...Vue.prototype.ManageHost, ...Vue.prototype.AgentHost]

// 右键菜单组件
import Contextmenu from 'vue-contextmenujs'
Vue.use(Contextmenu)

// 全局过滤
Vue.filter('parseTime', parseTime)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js